module.exports = __webpack_public_path__ + "static/media/comcast.56a90964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comcast.png
// module id = 826
// module chunks = 1